/**
 * Локализация значений услуг (таблица `service`).
 *
 * В БД русские значения хранятся в колонках `name`, `composition`, `technology`,
 * а английские переводы — в колонках с суффиксом `_en` (`name_en`,
 * `composition_en`, `technology_en`).
 *
 * Для английского (en) и арабского (ar) интерфейсов показываем ТОЛЬКО значения
 * из колонок `_en` (без отката на русские). Для русского (ru) используются
 * базовые колонки.
 */
import { normalizeLanguage } from "./config";

/** Языки, для которых источник данных — колонки `_en`. */
const EN_BASED_LANGUAGES = ["en", "ar"];

/** Суффикс языковой колонки: "en"/"ar" -> "_en", иначе "" (базовое значение). */
export const localizedSuffix = (language) =>
  EN_BASED_LANGUAGES.includes(normalizeLanguage(language)) ? "_en" : "";

/** Имя колонки услуги для текущего языка: name -> "name_en" при "en"/"ar". */
export const localizedFieldKey = (key, language) =>
  `${key}${localizedSuffix(language)}`;

const unwrap = (field) =>
  field && typeof field === "object" && "value" in field ? field.value : field;

/**
 * Значение поля услуги для текущего языка.
 * Для "en"/"ar" возвращаем только `key_en` (пусто, если перевод не заполнен),
 * для остальных языков — базовое `key`.
 * @param {object} service — запись услуги (значения в виде {value} или «сырые»)
 * @param {string} key — базовое имя поля ("name" | "composition" | "technology")
 * @param {string} language — код текущего языка
 */
export const getLocalizedServiceField = (service, key, language, fallback = "") => {
  const suffix = localizedSuffix(language);
  const field = suffix ? service?.[`${key}${suffix}`] : service?.[key];
  const value = unwrap(field);
  return value ?? fallback;
};
